export default {
  CONTACTS_SURVEYS_FETCHED: 'CONTACTS_SURVEYS_FETCHED',
  CONTACTS_SURVEY_LOAD: 'CONTACTS_SURVEY_LOAD',
  CONTACTS_SURVEY_DETAIL: 'CONTACTS_SURVEY_DETAIL',
  RESEARCH_TEMPLATES_FETCHED: 'RESEARCH_TEMPLATES_FETCHED',
  RESEARCH_TEMPLATES_LOAD: 'RESEARCH_TEMPLATES_LOAD',
  CONTACTS_SURVEY_BUTTON_LOAD: 'CONTACTS_SURVEY_BUTTON_LOAD',
};
